export const PAYMENT_LABELS = {
  USE_BUDDI_TO_PAY_WITH_INVOICE: 'USE_BUDDI_TO_PAY_WITH_INVOICE',
  USE_BUDDI_TO_PAY_WITHOUT_INVOICE: 'USE_BUDDI_TO_PAY_WITHOUT_INVOICE',
  REQUEST_INVOICES_AND_DOWNLOAD_PDF: 'REQUEST_INVOICES_AND_DOWNLOAD_PDF',
  DOWNLOAD_REPORT_AND_COMPLETE_JOB: 'DOWNLOAD_REPORT_AND_COMPLETE_JOB'
};

export const PAYMENT_DICT = Object.values(PAYMENT_LABELS).reduce(
  (acc, item, index) => {
    acc[index + 1] = item;
    return acc;
  },
  {}
);
